import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/typeQcReport',
    meta: { title: '型检品控报告' },
    component: Layout,
    redirect: '/typeQcReport/list',
    children: [
      {
        path: 'list',
        meta: { title: '型检品控报告', activeMenu: '/typeQcReport' },
        component: () => import('@/views/typeQcReport/Index.vue')
      },
      {
        path: 'detail',
        meta: { title: '型检品控报告详情', activeMenu: '/typeQcReport' },
        component: () => import('@/views/typeQcReport/Detail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增型检品控报告', activeMenu: '/typeQcReport' },
        component: () => import('@/views/typeQcReport/Add.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑型检品控报告', activeMenu: '/typeQcReport' },
        component: () => import('@/views/typeQcReport/Add.vue')
      }

    ]
  }

]
